// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v9pK","left":"styles_left__37S-d","desktopActions":"styles_desktopActions__1qYgE","title":"styles_title__3BUcP"};